module.exports = __webpack_public_path__ + "img/ic-manuel.fa2fa1b9.svg";